import funcion from './funcion/sicpe';
import sistema from "./sistema/sistemasSICPE";
import catalogos from "./catalogos/sicpe";


const funciones = {
  funcion: funcion,
  catalogos:catalogos,
  sistema: sistema
}

export default funciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/sicpeapi.js
// module id = null
// module chunks = 